import { render, staticRenderFns } from "./DIALOGUE.vue?vue&type=template&id=55581a5e&scoped=true&lang=pug"
import script from "./DIALOGUE.vue?vue&type=script&lang=js"
export * from "./DIALOGUE.vue?vue&type=script&lang=js"
import style0 from "./DIALOGUE.vue?vue&type=style&index=0&id=55581a5e&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55581a5e",
  null
  
)

export default component.exports